import React from 'react';

import { useRouter } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

export const RedeemCard = () => {
  const { navigate } = useRouter();

  const handleRedeemPress = () => {
    navigate(routes.rewards);
  };

  const youveGotEnoughText = t('youveGotEnoughCrowns');
  const grabYourRewardText = t('grabYourReward');
  const redeemNowText = t('redeemNow');

  return (
    <View style={styles.redeemCard}>
      <View style={styles.redeemTextContainer}>
        <Text
          style={styles.redeemText}
          accessibilityRole="text"
          accessibilityLabel={youveGotEnoughText}
        >
          {youveGotEnoughText}
        </Text>
        <Text
          style={styles.redeemText}
          accessibilityRole="text"
          accessibilityLabel={grabYourRewardText}
        >
          {grabYourRewardText}
        </Text>
      </View>
      <ActionButton
        variant={ActionButtonVariants.PRIMARY}
        size={ActionButtonSizes.SMALL}
        onPress={handleRedeemPress}
        style={styles.redeemButton}
        color={primitive.bk.$bbqBrown}
        accessibilityLabel={redeemNowText}
        _text={{
          lineHeight: 'xs',
        }}
      >
        {redeemNowText}
      </ActionButton>
    </View>
  );
};

export const styles = StyleSheet.create({
  redeemCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: primitive.spacing.$3,
    paddingHorizontal: primitive.spacing.$4,
    marginTop: primitive.spacing.$3,
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  redeemTextContainer: {
    flex: 1,
  },
  redeemText: {
    fontSize: primitive.fontSizes.xs,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.bk.$bbqBrown,
    lineHeight: 18,
  },
  redeemButton: {
    backgroundColor: primitive.bk.$meltyYellow,
    borderRadius: 20,
    paddingHorizontal: primitive.spacing.$5,
    paddingVertical: primitive.spacing.$2,
    height: 30,
  },
});
